import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import OrganizationFileTable from "./organization-file-table/OrganizationFileTable";
import { OrganizationFileEditForm } from "./organization-file-edit-dialog/OrganizationFileEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  createOrganizationFile,
  deleteOrganizationFile,
  fetchOrganizationFiles,
  updateOrganizationFile
} from "../_redux/organizationFileAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../_metronic/_helpers";
import ConfirmationDeleteModal from "../../Project/pages/modal-for-project/ConfirmationDeleteModal";
import LoadingAnimation from "../../Project/pages/loading-animation/LoadingAnimation";
import OrganizationFileTypeGrid from "./organization-fileTypeGrid/OrganizationFileTypeGrid";
import { useHistory, useLocation } from "react-router-dom";
import { getFolderLabel, ORGANIZATION_FILE_TYPE } from "../../../config/helper";
import { OrganizationDetailCard } from "./organization-detail-card/OrganizationDetail";
import InstructionList from "./instruction-list/InstructionList";
import { findNotificationOrg } from "../../Dashboard/crud/dashboardCrud";
import NotificationList from "./notification-list/NotificationList";
import { ActionButton } from "../../../../_metronic/_partials/controls/ActionButton";
import { ActionModal } from "../../../../_metronic/_partials/controls/ActionModal";
import { updateDocumentConfirmation } from "../_redux/organizationFileCrud";
// import AgreementForm from "./public/form-data-upload/form_pemahaman_dan_persetujuan.docx";

export const OrganizationFileCard = () => {
  const history = useHistory();
  const { currentState } = useSelector(
    state => ({ currentState: state.organizationFile }),
    shallowEqual
  );

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }

  const query = useQuery();

  const organizationTypeFile = query.get("type");

  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10
  });

  const [notificationOrg, setNotificationOrg] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);

  const dispatch = useDispatch();

  const { user } = useSelector(
    state => ({
      user: state.auth.user
    }),
    shallowEqual
  );

  const findNoticiation = async () => {
    const params = {
      pageNumber: 1,
      pageSize: 10,
      filter: {
        organization_uuid: user.organization_uuid
      }
    };
    const result = await findNotificationOrg(params);
    setNotificationOrg(result.data.data.items);
  };

  const onCloseNotification = notif => {
    setNotificationOrg(prev => {
      const temp = [...prev];
      const newArray = temp.filter(item => item.uuid !== notif.uuid);
      return newArray;
    });
  };

  useEffect(() => {
    findNoticiation();
  }, []);

  const {
    totalCount,
    entities,
    listLoading,
    actionsLoading,
    organizationForEdit
  } = currentState;

  useEffect(() => {
    if (organizationTypeFile) {
      dispatch(
        fetchOrganizationFiles({ ...queryParams, type: organizationTypeFile })
      );
    } else {
      dispatch(fetchOrganizationFiles(queryParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, organizationTypeFile]);

  const [openModal, setOpenModal] = useState({
    form: false,
    delete: false
  });
  const [row, setRow] = useState({});

  const uploadFile = values => {
    if (row.organization_uuid) {
      dispatch(updateOrganizationFile(values))
        .then(res => {
          toast.success(res.message, toastOption);
          setOpenModal(prev => ({ ...prev, form: false }));
          setRow({});
          dispatch(
            fetchOrganizationFiles({
              ...queryParams,
              type: organizationTypeFile
            })
          );
        })
        .catch(err => {
          console.log(`err`, err);
          // toast.error(err.message, toastOption);
        })
        .then(() => {
          dispatch(
            fetchOrganizationFiles({
              ...queryParams,
              type: organizationTypeFile
            })
          );
        });
    } else {
      const formData = new FormData();
      const { caption, file } = values;
      formData.append("type", organizationTypeFile);
      formData.append("file", file);
      formData.append("caption", caption);

      dispatch(createOrganizationFile(formData))
        .then(res => {
          toast.success(res.message, toastOption);
          setOpenModal(prev => ({ ...prev, form: false }));
          setRow({});
          dispatch(
            fetchOrganizationFiles({
              ...queryParams,
              type: organizationTypeFile
            })
          );
        })
        .catch(err => {
          console.log(`err`, err);
          // toast.error(err.message, toastOption);
        })
        .then(() => {
          dispatch(
            fetchOrganizationFiles({
              ...queryParams,
              type: organizationTypeFile
            })
          );
        });
    }
  };

  const deleteOrgFile = () => {
    dispatch(deleteOrganizationFile(row))
      .then(res => {
        toast.success(res.message);
        setRow({});
        setOpenModal(prev => ({ ...prev, delete: false }));
        dispatch(
          fetchOrganizationFiles({ ...queryParams, type: organizationTypeFile })
        );
      })
      .catch(err => {
        toast.error(err.message, toastOption);
      });
  };

  async function submitDocuments() {
    try {
      setLoading(true);

      const res = await updateDocumentConfirmation();

      history.go(0);

      toast.success("Organization Updated Successfully", toastOption);

      return;
    } catch (error) {
      toast.error(error.message, toastOption);
    } finally {
      setShowSubmitModal(false);
      setLoading(false);
    }
  }

  const downloadFormOrganization = type => {
    let data = {
      href: "",
      download: ""
    };

    switch (type) {
      case ORGANIZATION_FILE_TYPE.PARTNER_PROFILE:
        data.href = "/form-data-upload/form_profil_calon_mitra_mpz_dd.docx";
        data.download = "Form Profil calon mitra mpz";
        break;
      case ORGANIZATION_FILE_TYPE.AGREEMENT:
        data.href = "/form-data-upload/form_pemahaman_dan_persetujuan.docx";
        data.download = "Form pemahaman dan persetujuan";
        break;
      // case ORGANIZATION_FILE_TYPE.FINANCIAL_STATEMENTS:
      //   data.href = "/form-data-upload/form_pernyataan_rekening.docx";
      //   data.download = "Form pernyataan rekening";
      //   break;
      case ORGANIZATION_FILE_TYPE.SUBMISSION_LETTER:
        data.href = "/form-data-upload/form_pengajuan_mpz_dd.docx";
        data.download = "Form pengajuan";
        break;

      default:
        data = null;
        break;
    }

    if (data) {
      return (
        <a
          className="btn btn-info mx-1"
          style={{ textDecoration: "none", color: "#FFFFFF" }}
          href={data.href}
          download={data.download}
        >
          Download Form
        </a>
      );
    }
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading || listLoading} />
      <ConfirmationDeleteModal
        title="Hapus file organisasi"
        content="Apakah anda yakin ingin menghapus file organisasi ini?"
        show={openModal.delete}
        onHide={() => {
          setOpenModal(prev => ({ ...prev, delete: false }));
          setRow({});
        }}
        onClick={deleteOrgFile}
      />
      <OrganizationFileEditForm
        show={openModal.form}
        onHide={() => {
          setOpenModal(prev => ({ ...prev, form: false }));
          setRow({});
        }}
        submit={uploadFile}
        loading={actionsLoading}
        initialValues={{
          ...row,
          file: null
        }}
      />
      <ActionModal
        title="Konfirmasi Submit"
        message={
          "Dengan ini saya menyatakan semua data yang diupload dalam sistem ini valid"
        }
        show={showSubmitModal}
        loading={loading}
        onHide={() => setShowSubmitModal(false)}
        onSubmit={submitDocuments}
      />
      {!organizationTypeFile && (
        <NotificationList
          notifications={notificationOrg}
          onCloseNotification={onCloseNotification}
        />
      )}
      {/* // ? Submit Dokumen */}
      {!organizationTypeFile && (
        <>
          {entities.length !== 0 && (
            <Card>
              <CardBody>
                {organizationForEdit &&
                ["DATA_UPLOAD"].includes(organizationForEdit.simpz_status) ? (
                  <div className="row">
                    <div className="col d-flex justify-content-end">
                      <ActionButton
                        type="button"
                        text="Kirim Berkas Kelengkapan"
                        loading={loading}
                        onClick={() => setShowSubmitModal(true)}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center">
                    <strong>
                      Terimakasih sudah mengirimkan Dokumen Kelengkapan,
                      Silahkan tunggu sampai mendapatkan email bahwa dokumen
                      kelengkapan telah terverifikasi oleh tim MPZ Dompet Dhuafa
                    </strong>
                  </div>
                )}
              </CardBody>
            </Card>
          )}
        </>
      )}
      {!organizationTypeFile && <InstructionList />}
      {!organizationTypeFile && <OrganizationDetailCard />}
      <Card>
        <CardHeader
          title={getFolderLabel(organizationTypeFile) ?? "Data Lembaga"}
        >
          <CardHeaderToolbar>
            {downloadFormOrganization(organizationTypeFile)}
            {organizationTypeFile &&
              organizationForEdit &&
              organizationForEdit.simpz_status === "DATA_UPLOAD" && (
                <>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() =>
                      setOpenModal(prev => ({ ...prev, form: true }))
                    }
                  >
                    Tambah Dokumen
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mx-2"
                    onClick={() => history.goBack()}
                  >
                    Kembali
                  </button>
                </>
              )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* <div className="text-warning">
            <strong>Notes :</strong> {getNotesFile()}
          </div> */}
          {/* <OrganizationFileFilter /> */}
          {organizationTypeFile ? (
            <OrganizationFileTable
              setDeleteModal={() => {
                setOpenModal(prev => ({ ...prev, delete: true }));
                setRow({});
              }}
              setEditModal={() => {
                setOpenModal(prev => ({ ...prev, form: true }));
                setRow({});
              }}
              setRow={setRow}
              totalCount={totalCount}
              listLoading={listLoading}
              entities={entities}
              queryParams={queryParams}
              setQueryParams={setQueryParams}
              actionsLoading={actionsLoading}
            />
          ) : (
            <OrganizationFileTypeGrid entities={entities} />
          )}
        </CardBody>
      </Card>
    </>
  );
};
